import styled from 'styled-components';
import { Table as CommonTable } from 'components/common';

export const SearchAreaContainer = styled.div`
  margin-bottom: 10px;
  margin-left: 6px;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ActionButtons = styled.div`
  display: flex;
  margin-left: 10px;
  > * {
    margin-right: 10px;
  }
  ${p => p.theme.breakpoint.tablet} {
    flex-direction: column;
    > * {
      margin-left: 0px;
      margin-bottom: 10px;
      :last-child {
        margin-bottom: 0px;
      }
    }
    .ant-checkbox-wrapper + .ant-checkbox-wrapper {
      margin-left: 0px;
    }
  }
`;

export const Table = styled(CommonTable)`
  width: 100%;
  margin-top: 15px;
`;
